export default function MySQL_MONTH() {
  return (
    <div>
      <h2>MySQL_MONTH</h2>    </div>
  );
}